import { RefObject, useEffect, useState } from "react";

// True once the element comes within `rootMargin` of the viewport, and stays true.
// Unlike loading="lazy" (which Chrome starts 1250px+ ahead, before the page's main
// image has painted), this only fires for elements that are actually about to show,
// including tiles hidden off the side of a horizontally scrolling rail.
export function useNearViewport(
  ref: RefObject<Element>,
  rootMargin: string,
): boolean {
  const [isNear, setIsNear] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element || isNear) return;

    if (typeof IntersectionObserver === "undefined") {
      setIsNear(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setIsNear(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, rootMargin, isNear]);

  return isNear;
}
